export default __webpack_public_path__ + "1-2020-year-summary.png";